
const data = [
  {
    title: '人力资源体系概述',
    description: '人力资源体系本质上是帮助企业实现人力资源的合理有效配置，透过人力资源价值最大化，实现支撑企业战略达成的目标。'
  },
  {
    title: '服务内容',
    description: '职位系统\n' +
      '招聘管理\n' +
      '培训体系\n' +
      '绩效管理\n' +
      '薪酬激励'
  },
  {
    title: '服务特点',
    description: '人力资源体系强调系统性的思维与设计，关注企业整体利益，通过职位体系、招聘、培训以及薪酬激励系统化的解决问题；\n' +
      '构建企业统一的职位体系，根据职位所需的能力建立起相匹配的任职资格管理体系；\n' +
      '建立绩效管理的闭环管理系统，确保个人目标、部门目标与公司目标的关联；\n' +
      '薪酬管理体现企业的战略重点。'
  },
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/hr-hierarchy.js